import { useContext } from "react";

import { Navigate } from "react-router-dom";
import { UserContext } from "@context/user";
import { ComponentSpinner } from "@components/spinner";

// Bare `/brand` has no brand id to scope to yet — bounce to the active
// (or first) brand's dashboard once the topbar switcher has resolved one, or
// straight to its setup gate when it still has to say how it pays publishers.
const BrandIndexRedirect = () => {
    const { activeBrandId, brands } = useContext(UserContext);
    const setupPending = brands.find((brand) => brand.id === activeBrandId)?.setupPending;

    if (!activeBrandId) {
        return (
            <div className="flex justify-center py-24">
                <ComponentSpinner />
            </div>
        );
    }

    if (setupPending) {
        return <Navigate replace to={`/brand/${activeBrandId}/setup`} />;
    }

    return <Navigate replace to={`/brand/${activeBrandId}/dashboard`} />;
};

export default BrandIndexRedirect;
